import { DataSearchResultsViewModel, DocumentTypeV1 } from 'api'
import * as React from 'react'
import { Grid, Typography } from 'cs-kevlar-react'
import { Permissions } from '../../Permissions'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

interface IncidentProps {
  result: DataSearchResultsViewModel
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    key: {
      color: theme.palette.neutralButton.main,
    },
    marginTop: {
      marginTop: theme.spacing(10),
    },
  }),
)

export const Incident: React.FunctionComponent<IncidentProps> = (props) => {
  const classes = useStyles({})
  const { result } = props

  return (
    <React.Fragment>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.key}
          data-test="DataSearch:Incident:Key:type"
        >
          Type
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.key}
          data-test="DataSearch:Incident:Key:id"
        >
          Id
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.key}
          data-test="DataSearch:Incident:Key:agency"
        >
          Agency
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.key}
          data-test="DataSearch:Incident:Key:status"
        >
          Status
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.key}
          data-test="DataSearch:Incident:Key:isActive"
        >
          Is Active
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.key}
          data-test="DataSearch:Incident:Key:assignedToId"
        >
          Assigned To Id
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          data-test="DataSearch:Incident:Value:type"
        >
          {result.type}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          data-test="DataSearch:Incident:Value:id"
        >
          {result.id}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          data-test="DataSearch:Incident:Value:agency"
        >
          {result.agency}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          data-test="DataSearch:Incident:Value:status"
        >
          {result.status}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          data-test="DataSearch:Incident:Value:isActive"
        >
          {result.isActive}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          variant="body2"
          display="inline"
          data-test="DataSearch:Incident:Value:assignedToId"
        >
          {result.assignedToId}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.marginTop}>
        <Permissions
          permissions={JSON.parse(result.permissions)}
          data-test="DataSearch:Incident:Value:permissions"
        />
      </Grid>
    </React.Fragment>
  )
}
